export const moreWeOfferTextContent = {
  headingText: "What More Do We Offer?",
  btnText: "Discuss With Us",
  content: [
    {
      iconSrc: "/assets/stock-img/more_we_offer_img_01.webp",
      titleText: "Slot Game Animation",
    },
    {
      iconSrc: "/assets/stock-img/more_we_offer_img_02.webp",
      titleText: "Video Slot Game Software",
    },
    {
      iconSrc: "/assets/stock-img/more_we_offer_img_03.webp",
      titleText: "Slot Game Engine",
    },
    {
      iconSrc: "/assets/stock-img/more_we_offer_img_04.webp",
      titleText: "Casino Slot Software",
    },
  ],
};
